// extracted by mini-css-extract-plugin
export var hideEditor = "_m3-2";
export var infoIcon = "_m3-3";
export var label = "_m3-1";
export var labelContainer = "_m3-0";
export var readonlyText = "_m3-4";